export enum OperationServiceOrigin {
  CAMPAIGN = "CAMPAIGN",
  UNITARY = "UNITARY",
}
